<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="card">
                    <div class="card-header">Login</div> 
                    <div class="card-body">
                        <form method="POST" @submit.prevent="submit">
                        
                        <div class="form-group row">
                            <label for="email" class="col-md-4 col-form-label text-md-right">E-Mail Address</label> 
                            <div class="col-md-6">
                                <input id="email" type="email" name="email" v-model="email" required="required" autocomplete="email" autofocus="autofocus" class="form-control " 
                                    :class="{'is-invalid': hasError}" >
                                <form-error name="email" :errors="errors"></form-error>
                            </div>
                        </div> 
                                
                        <div class="form-group row">
                            <label for="password" class="col-md-4 col-form-label text-md-right">Password</label> 
                                <div class="col-md-6">
                                    <input id="password" type="password" v-model="password" name="password" required="required" autocomplete="current-password" class="form-control " >
                                </div>
                        </div> 
                        <div class="form-group row">
                            <div class="col-md-6 offset-md-4">
                                <div class="form-check">
                                    <input type="checkbox" name="remember" id="remember" class="form-check-input" value="remember" v-model="remember"> 
                                    <label for="remember" class="form-check-label">
                                        Remember Me
                                    </label>
                                </div>
                            </div>
                        </div> 
                        <div class="form-group row mb-0">
                            <div class="col-md-8 offset-md-4">
                                <button type="submit" class="btn btn-primary">
                                    Login
                                </button> 
                                
                                <router-link class="btn btn-link" :to="{name:'password.request'}">Forgot Your Password?</router-link>
                            </div>
                        </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>        
    </div>
</template>

<script>

import CurrentUser from '../../../mixins/CurrentUser';
import FormError from "../../Util/FormError";
import AuthService from '../../../services/AuthService';

export default {

    data: function () {
        return {
            email: '',
            password: '',
            remember: [],
            errors: {},
        }
    },

    mixins: [CurrentUser],
    components: {
        FormError,
    },

    methods: {
        submit: function () {
            this.errors = {};

            AuthService.login({ email: this.email, password: this.password })
                    .then( ({data}) => this.success(data) )
                    .catch( ({response}) => this.failed(response) );
        },
        success: function (data) {
            this.$store.commit('login', data);
            this.reset();
            if (data.logged_in_user.awaiting_authorisation) {
                this.$router.push({name:'auth.pending'});
                return;
            }
            this.$router.push({name:'home'});
        },
        failed: function(response){
            this.password = '';
            this.errors = response.data.errors;
        },  
        reset: function () {
            this.email = this.password = '';
            this.errors = {};
            this.remember = [];
        }
    },

    computed: {
        hasError: function() {  
            return (this.errors['email']);
        }
    }
}
</script>

